export const IS_RTL_SERVICE =
    document.getElementsByTagName('html')[0].getAttribute('dir') === 'rtl';
export const PC_BREAK_POINT = 960;

// active tab class
export const ACTIVE_ITEMS_CLASS = 'selected';
export const ACTIVE_WRAP_CLASS = 'is-show';

// custom-tab class
export const PARENT_DEPTH = 3;
export const TAB_SWIPE_CLASS = 'tab-swipe';
export const TAB_WRAP_CLASS = 'tab-swipe__wrap';
export const TAB_LIST_CLASS = 'tab-swipe__list';
export const TAB_LIST_ITEMS_CLASS = 'tab-swipe__list-items';
